import { Media } from "typings/microserviceModels/content-flex-module";
import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";

export class EditorialItemModel {
  public readonly id: string;
  public readonly text?: string;
  public readonly title?: string;
  public readonly uitkIconName?: string;
  public readonly view?: string;
  public readonly toggle?: string;
  public readonly iconSize?: string;
  public readonly padding?: string;
  public readonly media?: Media;
  public readonly context?: ExtendedContextStore;

  /* istanbul ignore next */
  public constructor(
    id: string,
    text?: string,
    title?: string,
    uitkIconName?: string,
    view?: string,
    toggle?: string,
    iconSize?: string,
    padding?: string,
    media?: Media,
    context?: ExtendedContextStore
  ) {
    this.id = id;
    this.text = text;
    this.title = title;
    this.uitkIconName = uitkIconName;
    this.view = view;
    this.toggle = toggle;
    this.iconSize = iconSize;
    this.media = media;
    this.context = context;
    this.padding = padding;
  }
}

export default EditorialItemModel;
